import type { TencentModelConfig } from './types';
import { klingConfigs } from './configs/kling';
import { seedanceConfigs } from './configs/seedance';

/**
 * 模型配置映射
 */
export const tencentModelConfigs: Record<string, TencentModelConfig> = {
    ...klingConfigs,
    ...seedanceConfigs,
};
